var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4266",
    "data-name": "Grupo 4266",
    transform: "translate(-555.5 -276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4193",
    "data-name": "Grupo 4193",
    transform: "translate(555.5 275.999)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_60",
    "data-name": "Elipse 60",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(0 26.001) rotate(-90)",
    fill: "#13a841"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M14.207,5.076a1.1,1.1,0,1,1,1.575,1.544L9.912,13.955a1.1,1.1,0,0,1-1.588.029l-3.889-3.89A1.1,1.1,0,1,1,5.995,8.536l3.078,3.077,5.106-6.505a.347.347,0,0,1,.029-.032Z",
    transform: "translate(559.057 279.255)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/Check_green.538fb6fd.svg";
export { ForwardRef as ReactComponent };